<template>
  <div class="flex items-center justify-around">
    <div class="max-w-lg">
      <div class="text-4xl font-bold text-gray-700 text-center mb-2">Create Your Scrum Room</div>
      <div v-if="!$page.props.user" class="mt-4">
        <label for="game-name" class="block text-lg font-bold text-gray-700">Your name</label>
        <input
            v-model="userName"
            type="text"
            class="shadow focus:ring-indigo-500 focus:border-blue-400 block w-full sm:text-sm border-gray-300 rounded-md"
            placeholder="Your name"
        />
      </div>

      <div v-if="isVipLink" class="mt-4">
        <label for="vip" class="block text-lg font-bold text-gray-700">VIP Code:</label>
        <div class="mt-1">
          <input
              id="vip"
              v-model="vipCode"
              type="text"
              name="game-name"
              class="shadow focus:ring-indigo-500 focus:border-blue-400 block w-full sm:text-sm border-gray-300 rounded-md"
              placeholder="VIP Code"
          />
        </div>
      </div>

      <div class="mt-4">
        <label for="game-name" class="block text-lg font-bold text-gray-700">Room's name</label>
        <div class="mt-1">
          <input
              id="id-game-name"
              v-model="gameName"
              type="text"
              name="game-name"
              class="shadow focus:ring-indigo-500 focus:border-blue-400 block w-full sm:text-sm border-gray-300 rounded-md"
              placeholder="Room's name"
          />
        </div>
      </div>

      <div class="mt-4">
        <label for="game-name" class="block text-lg font-bold text-gray-700 mb-1">Voting system</label>
        <div class="rounde-md bg-gray-100 px-4 py-5 sm:px-6">
          <div class="mb-2">
            <a-select ref="select" v-model:value="selectedOption" class="w-full shadow">
              <a-select-option value="value_0">∞, ?, 0, 1, 2, 3, 5, 8, 13, 21, 34, 55, 89</a-select-option>
              <a-select-option value="value_1">∞, ?, 0, 1, 2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 24, 26, 30
              </a-select-option>
              <a-select-option value="value_2">∞, ?, 0, 1, 2, 4, 8, 16, 32, 64</a-select-option>
              <a-select-option value="value_3">∞, ?, XS, S, M, L, XL</a-select-option>
              <a-select-option value="custom">custom</a-select-option>
            </a-select>
          </div>

          <div>
            <question-maker v-if="selectedOption === 'custom'" :limit="20" pl="md" text=""
                            :questions="submitForm.columns"></question-maker>

            <!--            <div class="mt-4 flex justify-between">-->
            <!--              <button type="button" v-if="selectedOption === 'custom'" @click="saveTemplate()"-->
            <!--                      class="bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 rounded shadow"-->

            <!--              >-->
            <!--                Save Template-->
            <!--              </button>-->
            <!--            </div>-->
          </div>
        </div>
      </div>

      <small> ∞: Task Breakdown.</small>
      <small> ?: Unsure.</small>
      <a-divider></a-divider>
      <div class="mt-4">
        <button
            class="p-2 bg-blue-500 hover:bg-blue-400 w-full rounded-lg shadow text-md font-bold uppercase text-white"
            @click="startGame()">
          {{ clickText ?? "Start the game" }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {ref, computed, watchEffect, toRefs, defineComponent, reactive, getCurrentInstance, onMounted} from "vue";
import AppLayout from "@/Layouts/AppLayout";
import {Inertia} from "@inertiajs/inertia";
import SelectMenu from "../../Components/SelectMenu/SelectMenu";
import {message} from "ant-design-vue";
import QuestionMaker from "@/Components/QuestionMaker/QuestionMaker";

const defaultVotingSystemOptions = {
  value_0: ["∞", "?", "0", "1", "2", "3", "5", "8", "13", "21", "34", "55", "89"],
  value_1: ["∞", "?", "0", "1", "2", "4", "6", "8", "10", "12", "14", "16", "18", "20", "24", "26", "30"],
  value_2: ["∞", "?", "0", "1", "2", "4", "8", "16", "32", "64"],
  value_3: ["∞", "?", "XS", "S", "M", "L", "XL"],
};

export default {
  components: {
    QuestionMaker,
    AppLayout,
    SelectMenu,
  },
  props: ["clickText", 'isTeam'],
  setup(props, context) {
    const submitForm = reactive({
      columns: [
        {
          sort: 1,
          subject: "∞",
        },
        {
          sort: 2,
          subject: "?",
        },
      ],
    });
    const selectedOption = ref("value_0");
    const selectedCustoms = ref([]);
    const vipCode = ref("");
    const gameName = ref("");
    const userName = ref("");
    const isVipLink = document.URL.includes("AGILESUITE01");

    const votingNumber = computed(() => {
      if (selectedOption.value === "custom") {
        return selectedCustoms.value;
      } else {
        return defaultVotingSystemOptions[selectedOption.value];
      }
    });
    const app = getCurrentInstance();

    // const getTemplates = () => {
    //
    // }
    //
    // onMounted(() => {
    //   getTemplates();
    // });
    // const saveTemplate = () => {
    // }
    //

    const startGame = () => {
      if (!gameName.value) {
        message.error("Room name is required.");
        return;
      }

      if (selectedOption.value === "custom" && submitForm.columns === 0) {
        message.error("Voting number is required.");
        return;
      }

      if (!app.ctx.isUserLoggedIn && !userName.value) {
        message.error("User name is required.");
        return;
      }

      const getVotingNumbers = (numbers) => {
        return numbers.map((item) => {
          return item.subject;
        });
      };

      axios
          .post(route("planning-rooms.create"), {
            is_team: props.isTeam,
            room_name: gameName.value,
            user_name: userName.value,
            vip_code: vipCode.value,
            voting_number: selectedOption.value === "custom" ? getVotingNumbers(submitForm.columns) : votingNumber.value,
          })
          .then((response) => {
            if (response.data.success) {
              message.success("Your room is created.");
              context.emit("created", response.data.data.room_id);
            } else {
              message.error(response.data.message, 5);
            }
          })
          .catch((error) => {
            console.log(error);
          });
    };

    return {
      submitForm,
      isVipLink,
      vipCode,
      gameName,
      userName,
      startGame,
      votingNumber,
      selectedOption,
      selectedCustoms,
    };
  },
  data() {
    return {
      isUserLoggedIn: false,
    };
  },
  mounted() {
    this.isUserLoggedIn = !!this.$page.props.user;
  },
  methods: {},
};
</script>
